import {
  FetchUsersStatsResponse,
  FetchFunnelChartResponse,
  FetchRfmChartResponse,
  FetchPortfolioStatsResponse,
  FetchPortfoliosPerformanceResponse,
  FetchDashboardResponse,
  AdjustReportsResponse,
} from '../types/analytics';
import { toQueryParams } from '../utils/request';
import { ApiService } from './common/ApiService';

class AnalyticsService extends ApiService {
  pathname = 'admin/analytics';
  fetchUsersStats = async () => this.get<FetchUsersStatsResponse>(`${this.pathname}/user-analytics/users-stats`);

  fetchFunnelChart = async () => this.get<FetchFunnelChartResponse>(`${this.pathname}/user-analytics/funnel-chart`);

  fetchRfmChart = async () => this.get<FetchRfmChartResponse>(`${this.pathname}/user-analytics/rfm-chart`);

  fetchPortfolioStats = async () =>
    this.get<FetchPortfolioStatsResponse>(`${this.pathname}/portfolio-analytics/portfolio-stats`);

  fetchPortfoliosPerformance = async () =>
    this.get<FetchPortfoliosPerformanceResponse>(`${this.pathname}/portfolio-analytics/portfolios-performance`);

  fetchDashboard = async (data: { start_date: string; end_date: string }) =>
    this.get<FetchDashboardResponse>(`${this.pathname}/portfolio-analytics/dashboard?${toQueryParams(data)}`, {
      timeout: 60_000,
    });

  fetchAdjustedDashboard = async (data: { start_date: string; end_date: string }) =>
    this.get<AdjustReportsResponse>(`${this.pathname}/portfolio-analytics/adjust-report?${toQueryParams(data)}`);
}

export const analyticsService = new AnalyticsService();
